import { Quote } from "lucide-react";
import { Reveal, SectionBadge } from "./Shared";
import { TESTIMONIALS, IMAGES } from "../data";

export default function Testimonials() {
  return (
    <section className="bg-bone py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="flex flex-wrap items-end justify-between gap-10">
          <div>
            <Reveal>
              <SectionBadge>05 — Kind Words</SectionBadge>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 max-w-xl font-serif text-5xl font-medium leading-[0.95] tracking-tighter text-ink md:text-7xl">
                Squeezed with love, <span className="italic text-melon">sipped with joy</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2} className="hidden md:block">
            <div className="w-40 overflow-hidden rounded-full border border-leaf/15">
              <img
                src={IMAGES.lifestyle}
                alt="Happy customer drinking fresh juice"
                data-testid="testimonial-image"
                className="aspect-[3/4] w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12} className={i === 1 ? "md:translate-y-10" : ""}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="flex h-full flex-col rounded-[32px] border border-leaf/15 bg-cream p-8 md:p-10"
              >
                <Quote className="h-8 w-8 text-sun" strokeWidth={1.5} />
                <blockquote className="mt-6 flex-1 font-serif text-2xl font-medium italic leading-snug text-ink">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-8 border-t border-leaf/15 pt-5">
                  <p className="text-sm font-medium tracking-wide text-leaf">{t.name}</p>
                  <p className="mt-0.5 text-[11px] uppercase tracking-[0.25em] text-leaf/50">{t.place}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
